/**
 * Constants for merchant details component
 */

/**
 * Revenue card configurations for first row
 */
export const REVENUE_CARDS_ROW_1 = [
    { key: 'totalRevenue', title: "Total Revenue" },
    { key: 'campaignRevenue', title: "Campaign Revenue" },
    { key: 'recoveredRevenue', title: "Recovered Revenue" },
    { key: 'smartDiscountRevenue', title: "Smart Discount Revenue" }
];

/**
 * Revenue card configurations for second row
 */
export const REVENUE_CARDS_ROW_2 = [
    { key: 'totalOrderProtected', title: "Total Orders Protected", isNumber: true },
    { key: 'recoveredRevenuePerOrder', title: "Recovered Revenue Per Order", formatFn: (val) => Math.ceil(val) },
    { key: 'revenueFromProtectedOrders', title: "Revenue from Protected Orders", formatFn: (val) => Math.ceil(val) },
    { key: 'ratioOfOrdersProtected', title: "Ratio of Orders Protected", suffix: '%' }
];

/**
 * Revenue card configurations for third row
 */
export const REVENUE_CARDS_ROW_3 = [
    { key: 'totalCouponsBlocked', title: "Total Coupons Blocked", isNumber: true },
    { key: 'uniqueCouponBlocked', title: "Unique Coupons Blocked", isNumber: true },
    { key: 'veeperROI', title: "Veeper ROI", suffix: '%' },
    { key: 'total_fees', title: "Total Fees", field: "total_fees", edit: true, linkUrl: "placement-edit" }
];

/**
 * Active store action configurations
 */
export const ACTIVE_STORE_ACTIONS = [
    { label: 'Collections', handlerKey: 'handleActionCollections' },
    { label: 'Products', handlerKey: 'handleActionProduct' }
];

/**
 * Table configurations for merchant details
 */
export const TABLE_CONFIGS = [
    { size: 8, loadingKey: 'isBlockedOrderLoading', dataKey: 'blocked_orders', title: 'Coupon Blocker List', subtitle: 'Blocked Orders' },
    { size: 4, loadingKey: 'isCouponLoading', dataKey: 'coupon_list', title: 'Coupons', subtitle: 'List of Discounts' }
];

/**
 * Pagination options for tables
 */
export const TABLE_PAGINATION_OPTIONS = [20, 30, 40, 60];
export const DEFAULT_TABLE_ENTRIES = 20;

/**
 * Common inline styles
 */
export const COMMON_STYLES = {
    rowMargin: { margin: "10px 0" },
    flexCenter: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' },
    spinnerCenter: { display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }
};

